import React from 'react';

const SellerAliasBadge = ({ className = '', sellerAlias }) => {
    if (sellerAlias) {
        return (
            <span
                className={`seller-alias-badge badge badge-dark badge-inline text-nowrap d-inline-block text-truncate ${className}`}>
                {sellerAlias}
            </span>
        );
    } else {
        return null;
    }
};

export default SellerAliasBadge;
